<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import { vpqueryVp, getCombo } from '../../../../api/home.js';
import config from '../../../../../configHttp';
export default {
	name: 'VPSupplierData',
	data() {
		return {
			/* 搜索栏 */
			searchlist: getdata().searchlist,
			searchdata: getdata().searchdata,
			overlength: 0,
			searchdiag: false,
			/* 搜索栏 */
			/* 表格 */
			pagination: getdata().pagination,
			headData: JSON.parse(localStorage.getItem('VPSupplierDataheadData')) || getdata().headData,
			outlist: JSON.parse(localStorage.getItem('VPSupplierDataoutlist')) || [],
			shaidiag: false,
			tableData: [],
			tablekey: 0,
			tableHeight: 'calc(100vh - 325px )',
			Count: 0,
			sort: '',
			order: ''
			/* 表格 */
		};
	},
	mounted() {},
	activated() {
		this.searrchForData();
	},
	created() {
		this.searrchForData();
	},
	methods: {
		//表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			localStorage.setItem('VPSupplierDataoutlist', JSON.stringify(e.nochooselist));
			localStorage.setItem('VPSupplierDataheadData', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
			this.getCloseoutPageList();
		},
		selectionchange(e) {
			this.Count = e.length;
		},
		searrchForData() {
			let params = {};
			params.criteriaJson = JSON.stringify(this.searchdata);
			params.page = this.pagination.pageNum;
			params.rows = this.pagination.pageSize;
			params.sort = this.sort;
			params.order = this.order;
			vpqueryVp(params).then(res => {
				if (res.data.code == '200') {
					this.tableData = res.data.data.map(v => {
						v.clearingDate = this.formatDate(v.clearingDate);
						v.documentDate = this.formatDate(v.documentDate);
						v.paymentDate = this.formatDate(v.paymentDate);
						return v;
					});
					this.pagination.total = res.data.count;
					let paramsqj = {};
					paramsqj.name = 'VP_DOCUMENT_TYPE';
					getCombo(paramsqj).then(res => {
						if (res.data.code == '200') {
							this.searchlist = getdata().searchlist;
							this.searchlist[2].selectval = res.data.data.map(v => {
								return {
									label: v.value,
									value: v.key
								};
							});
						}
					});
				}
			});
		},
		formatDate(value) {
			// 时间戳转换日期格式方法
			if (value == null) {
				return value;
			} else {
				const date = new Date(value);
				const y = date.getFullYear(); // 年
				let MM = date.getMonth() + 1; // 月
				MM = MM < 10 ? '0' + MM : MM;
				let d = date.getDate(); // 日
				d = d < 10 ? '0' + d : d;
				return y + '-' + MM + '-' + d;
			}
		},
		sortchange(data) {
			this.sort = data.prop;
			this.order = data.order == 'ascending' ? 'asc' : 'desc';
			this.searrchForData();
		},

		/* 搜索栏 */
		geOoverLength(e) {
			this.overlength = e;
		},
		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.searrchForData();
		},
		forUpdateSearch() {
			this.searchdiag = true;
		},
		closeSearch() {
			this.searchdiag = false;
		},
		saveChange(e) {
			this.searchdiag = false;
		},
		/* 搜索栏 */
		/* 表格 */
		currentChange(e) {
			this.pagination.pageNum = e;
			this.searrchForData();
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.searrchForData();
		}
		/* 表格 */
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
